<template>
    <div class="icon-Bull"></div>
</template>